import NotFound from "../pages/utility/NotFound";

export default function CMSRouter() {
  return <NotFound />;
}
